export const css = {
	root: '_1wj5cyPl',
	studyplan_carousel: '_1vMcnwgn',
	domain_carousels: '_3dtNpILY',
	' _key': 'ascm-theme/ascm/explore-view/carousel-view'
};

export default css;
